"use client";

import { cn } from "cy-fe/src/utils/cn";
import { useLoadingSpinnerConfig } from "./LoadingSpinnerContext";

interface LoadingSpinnerProps {
  className?: string;
  /** Logo image source. Overrides context value. */
  logoSrc?: string;
  /** Logo alt text. Overrides context value. */
  logoAlt?: string;
  /** Additional CSS classes for the logo image element. Overrides context value. */
  imgClassName?: string;
  "data-testid"?: string;
}

export function LoadingSpinner({
  className,
  logoSrc,
  logoAlt,
  imgClassName,
  "data-testid": dataTestId,
}: LoadingSpinnerProps) {
  const baseTestId = dataTestId || "loading-spinner";
  const config = useLoadingSpinnerConfig();

  const resolvedLogoSrc = logoSrc ?? config?.logoSrc;
  const resolvedLogoAlt = logoAlt ?? config?.logoAlt ?? "Logo";
  const resolvedImgClassName = imgClassName ?? config?.imgClassName;

  return (
    <div
      data-testid={baseTestId}
      className={cn(
        "relative inline-flex h-[7rem] w-[7rem] items-center justify-center",
        className,
      )}
    >
      {/* Spinning ring — 270° arc (3 of 4 border sides colored, left transparent) */}
      <div className="border-t-primary-500 border-r-primary-500 border-b-primary-500 absolute inset-0 animate-spin rounded-full border-[1px] border-l-transparent" />

      {/* Static centered logo (does not spin) */}
      {resolvedLogoSrc && (
        <img
          src={resolvedLogoSrc}
          alt={resolvedLogoAlt}
          className={cn("h-[70%] w-[70%] object-cover", resolvedImgClassName)}
        />
      )}
    </div>
  );
}
